export const usd = (amount) => {
  return isNaN(amount)
    ? amount
    : parseFloat(amount).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
};
